export const styles = theme => ({
  container: {
    width: 'initial',
    marginLeft: theme.spacing.unit * 2,
    marginRight: theme.spacing.unit,
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit
  },

  qty: {
    width: 50,
  }
})



// WEBPACK FOOTER //
// ./src/components/Buses/components/CreateBusForm/styles.js